import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.replace";
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedNumber } from 'react-intl';
import ROUNDED_STAR from '../../../static/img/icon/star-rounded.svg';

var fiveStarRender = function fiveStarRender(_ref) {
  var rating = _ref.rating,
      stars = _ref.stars,
      count = _ref.count;
  return React.createElement(Fragment, null, stars, rating, count);
};

fiveStarRender.propTypes = {
  rating: PropTypes.node,
  stars: PropTypes.node,
  count: PropTypes.node
};

var singleStarRender = function singleStarRender(_ref2) {
  var rating = _ref2.rating,
      stars = _ref2.stars,
      count = _ref2.count;
  return React.createElement(Fragment, null, rating, stars, count);
};

singleStarRender.propTypes = {
  rating: PropTypes.node,
  stars: PropTypes.node,
  count: PropTypes.node
};
export var StarRating = function StarRating(_ref3) {
  var rating = _ref3.rating,
      showRatingNumber = _ref3.showRatingNumber,
      count = _ref3.count,
      className = _ref3.className,
      singleStar = _ref3.singleStar,
      children = _ref3.children;
  var ratingComponent = null;

  if (showRatingNumber && rating > 0) {
    ratingComponent = React.createElement("span", {
      className: "ratings__rating ratings--child"
    }, React.createElement(FormattedNumber, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      value: rating
    }));
  }

  var starsComponent;

  if (singleStar) {
    starsComponent = React.createElement("div", {
      className: "ratings__stars-container ratings--child"
    }, React.createElement(Isvg, {
      className: "ratings__star-icon ratings--star-icon-single",
      src: ROUNDED_STAR
    }));
  } else {
    starsComponent = React.createElement("div", {
      className: "ratings__stars-container ratings--child"
    }, React.createElement("div", {
      className: "ratings__stars-off"
    }, React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    })), React.createElement("div", {
      className: "ratings__stars-on",
      style: {
        width: "".concat(Math.round(rating * 2) * 10, "%")
      }
    }, React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    }), React.createElement(Isvg, {
      className: "ratings__star-icon",
      src: ROUNDED_STAR
    })));
  }

  var countComponent = null;

  if (parseInt(String(count).replace(/[^\d]/g, ''), 10) > 0) {
    countComponent = React.createElement("span", {
      className: "ratings__count ratings--child"
    }, "(", typeof count === 'number' ? React.createElement(FormattedNumber, {
      value: count
    }) : count, ")");
  }

  var render;

  if (typeof children === 'function') {
    render = children;
  } else if (singleStar) {
    render = singleStarRender;
  } else {
    render = fiveStarRender;
  }

  return React.createElement("div", {
    className: classNames('ratings ratings--display', className)
  }, render({
    rating: ratingComponent,
    stars: starsComponent,
    count: countComponent
  }));
};
StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  className: PropTypes.string,
  showRatingNumber: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  singleStar: PropTypes.bool,
  children: PropTypes.func
};